// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mP_wR","left":"styles_left__8ttkI"};